import Input from '../other/Input'
import SubmitButton from '../other/SubmitButton'
import vSelect from 'vue-select'

export const form_mix = {
  components: { Input, SubmitButton, vSelect },
  computed: {
    isValid() {
      let valid = true

      this.requiredKeys.forEach(key => {
        if (!this.formData[key]) {
          valid = false
        }
      })
      return valid
    }
  }
}